import React, { Component } from 'react';
import  LoadingPage from '../../../loading-page/loading-page';
import $ from 'jquery';
import SideMenuLoader from './sidemenu-loader';
import axios from 'axios';
import { NavLink,Router } from 'react-router-dom'
import './sidemenu.css';
import API_Config from '../../../API_Config';

class SideMenu extends Component {


    constructor(props) {
        super(props);
        this.state = {
            rpt_des: [],
            slug   : '',
            Isrender : true,
            error: null,
            isLoaded:false
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.GetContentData();
        }, 200);

        console.log('hhhkij');

        var body = $("html, body");
        body.stop().animate({scrollTop:400}, 500, 'swing', function() {
        });


        $('body').on('click','.rpt_disc',function () {

            $('*[id^="collapse1"]').removeClass('in');
            $('#collapse1'+ this.id).addClass('in');

        })



    }
    GetContentData() {

        let url = API_Config.http_url + API_Config.end_point.category ;
        // fetch(url)
        //     .then(res => res.json())
        //     .then(
        //         (result) => {
        //             // setTimeout( function() {
        //                 this.setState({
        //                     isLoaded: true,
        //                     rpt_des: result
        //                 });
        //             setTimeout(() => {
        //                 if(localStorage.getItem('catData') != "") {
        //                     $('*[id^="collapse1"]').removeClass('in');
        //                     $('#collapse1'+ localStorage.getItem('catData')).addClass('in');
        //                 }
        //
        //             }, 500);
        //             // },300);
        //         },
        //         (error) => {
        //             // this.setState({
        //             //     isLoaded: true,
        //             //     error
        //             // });
        //         }
        //     );

        axios.get(url)
            .then(res => {
                // const posts = res.data.data.children.map(obj => obj.data);
                //
                // this.setState({ posts });

                // setTimeout( function() {
                console.log("data coming from db",res)
                this.setState({
                    isLoaded: true,
                    rpt_des: res.data
                });
                setTimeout(() => {
                    if(localStorage.getItem('catData') != "") {
                        $('*[id^="collapse1"]').removeClass('in');
                        $('#collapse1'+ localStorage.getItem('catData')).addClass('in');
                        // localStorage.setItem("sub_category", res.data);
                    }

                }, 500);
            });

    }
    shouldComponentUpdate(nextProps) {
        const differentTitle = this.state.isLoaded !== nextProps.isLoaded;
        const differentDone = this.props.done !== nextProps.done
        return differentTitle;
    }

    // shouldComponentUpdate() {
    //     return false;
    // }

    getCatData(param) {
        localStorage.setItem('catData',param);
    }

    render() {
        const {isLoaded,rpt_des} = this.state;
        if (!isLoaded) {
            return (

                    <SideMenuLoader />

            )
        } else {
            return (
            <div class="cate_sidemenu">
                <h5 class="hidden-xs">CATEGORIES</h5>
                <div class="panel-group" id="accordion">

                    {this.state.rpt_des.map(i => {
                        return (
                          // <SideMenuItem title={i.title} slug={i.slug} catData={this.getCatData} subCategories={i.sub_category} />
                          // <a  data-toggle="collapse" data-parent="#accordion" href={"#collapse"+i.slug}></a>
                          // <a href={'/industry-reports/category/'+i.slug} >
                          //     <h4 class="panel-title">
                          //         {i.title}

                          //         <i class="indicator fa fa-angle-down  pull-right"></i>
                          //     </h4>
                          // </a>
                          // <a href={'/industry-reports/category/'+i.slug+"/"+j.slug}>
                          //     <li>
                          //         <i class="fa fa-angle-right"></i>
                          //         {j.title}
                          //     </li>
                          // </a>
                            <div class="panel panel-default">
                                <div class="panel-heading rpt_disc" id={i.slug} onClick={() => this.getCatData(i.slug)}>
                                    <NavLink data-toggle="collapse" data-parent="#accordion" to={"#collapse"+i.slug}></NavLink>
                                    <NavLink to={'/industry-reports/category/'+i.slug} >
                                        <h4 class="panel-title">
                                            {i.title}

                                            <i class="indicator fa fa-angle-down  pull-right"></i>
                                        </h4>
                                    </NavLink>


                                </div>
                                <div id={"collapse1"+i.slug} class="panel-collapse collapse">
                                    <div class="panelb">
                                {

                                    i.sub_category.map(j => {
                                    return (

                                                    <ul class="subcate_title hf">
                                                        <NavLink to={'/industry-reports/category/'+i.slug+"/"+j.slug}>
                                                            <li>
                                                                <i class="fa fa-angle-right"></i>
                                                                {j.title}
                                                            </li>
                                                        </NavLink>

                                                    </ul>

                                    )
                                })

                                }
                                    </div>
                                </div>

                            </div>
                        )
                    })}

                </div>
                <div>
                    <form id="pageDetails">
                        <input type="hidden" name="pag_cat_id" id="pag_cat_id" value="" />
                        <input type="hidden" name="pag_sub_id" id="pag_sub_id" value="" />
                        <input type="hidden" name="pag_hub_id" id="pag_hub_id" value="" />
                    </form>
                </div>
            </div>
            );
        }





    }


}


export default SideMenu;


// WEBPACK FOOTER //
// ./src/industry-reports/content/sidemenu/sidemenu.js